export enum LockTypes {
  UNLOCKABLE,
  LOCKABLE,
}
